const NAVIGATION_SCOPED_QUERY_KEYS = Object.freeze([
  "account",
  "role",
  "redirect",
  "from",
  "plan",
  "planName",
  "frequency",
  "promo",
  "verified",
]);

export function mergeRouteQuery(toQuery = {}, fromQuery = {}) {
  // Destination values are authoritative. Preserve general attribution query
  // values, but never carry account-flow state into a different navigation.
  const merged = { ...fromQuery, ...toQuery };
  for (const key of NAVIGATION_SCOPED_QUERY_KEYS) {
    if (Object.prototype.hasOwnProperty.call(toQuery, key)) {
      merged[key] = toQuery[key];
    } else {
      delete merged[key];
    }
  }
  return merged;
}

export { NAVIGATION_SCOPED_QUERY_KEYS };
